import React from 'react';

export default function index() {
  return (
    <footer id="sticky-footer">
      <div className="bottom-footer mt-4 py-1">
        <p className="text-white text-center mt-2">
          Copyright &copy; 2020 Kuma Book. Build By Bilkis Ismail
        </p>
      </div>
    </footer>
  );
}
